import { render, staticRenderFns } from "./WorkoutModal.vue?vue&type=template&id=01e523ba&scoped=true&"
import script from "./WorkoutModal.vue?vue&type=script&lang=js&"
export * from "./WorkoutModal.vue?vue&type=script&lang=js&"
import style0 from "./WorkoutModal.vue?vue&type=style&index=0&id=01e523ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e523ba",
  null
  
)

export default component.exports